import { createSignal } from "solid-js";

export type Me = {
  email: string | null;
  is_admin: boolean;
};

export type AuthState =
  | { status: "loading" }
  | { status: "anon" }
  | { status: "authed"; me: Me };

const [auth, setAuth] = createSignal<AuthState>({ status: "loading" });

export { auth };

export async function refreshMe(): Promise<AuthState> {
  try {
    const res = await fetch("/api/auth/me", { credentials: "same-origin" });
    if (res.status === 401 || res.status === 403) {
      setAuth({ status: "anon" });
      return { status: "anon" };
    }
    if (!res.ok) throw new Error(`HTTP ${res.status}`);
    const json = (await res.json()) as Me;
    const next: AuthState = { status: "authed", me: json };
    setAuth(next);
    return next;
  } catch {
    setAuth({ status: "anon" });
    return { status: "anon" };
  }
}

export async function logout(): Promise<void> {
  try {
    await fetch("/api/auth/logout", { method: "POST", credentials: "same-origin" });
  } catch {
    /* ignore; cookie will still be cleared by server, and we fall back to anon */
  }
  setAuth({ status: "anon" });
}

export const PUBLIC_SPA_ROUTES: ReadonlyArray<string> = ["/login", "/thank-you"];

export function isPublicRoute(path: string): boolean {
  return PUBLIC_SPA_ROUTES.some(
    (p) => path === p || path.startsWith(p + "/") || path.startsWith(p + "?"),
  );
}
